export default __webpack_public_path__ + "static/media/image.seth-it-solutions-pvt-ltd-.d2e8b40d.png";